"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scope = void 0;
var _index = require("../../types/index.cjs");
const Scope = exports.Scope = {
  EXCLUDE_ARCHIVED_NEWSROOMS: {
    'newsroom.status': {
      $nin: [_index.Newsroom.Status.ARCHIVED]
    }
  }
};